<script>

import AddTrainingCategoryModal from "@/components/modals/AddTrainingCategoryModal.vue";
import DeleteWithConfirmation from "@/components/DeleteWithConfirmation.vue";
import PerPageSelect from "@/components/ui/PerPageSelect.vue";

export default {
    components: {DeleteWithConfirmation, AddTrainingCategoryModal, PerPageSelect},
    data() {
        return {
            loading: true,
            downloading: false,
            data: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            sort: {
                field: 'id',
                order: 'desc'
            },
            controller: null,
            search: '',
            searchDebounceTimer: null,
            perPage: parseInt(localStorage.getItem('perPage_trainingTags') || '10'),
        }
    },
    methods: {
        loadData() {
            this.controller = new AbortController();
            this.loading = true;
            window.scrollTo({top: 0});
            let params = {
                page: this.meta.current_page,
                per_page: this.perPage,
                sort: this.sort.field,
                order: this.sort.order,
                search: this.search || undefined,
            };
            axios.get('/training-tags', {
                signal: this.controller.signal,
                params: params
            }).then(response => {
                this.data = response.data.data;
                this.meta.current_page = response.data.meta.current_page;
                this.meta.total = response.data.meta.total;
                this.meta.per_page = response.data.meta.per_page;
            }).catch(error => {
            }).finally(() => {
                this.loading = false;
            })
        },
        onPageChange(page) {
            this.controller.abort();
            this.meta.current_page = page;
            this.loadData();
        },
        onSort(field, order) {
            this.controller.abort();
            this.sort = {field, order};
            this.loadData();
        },
        onSearchInput() {
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = setTimeout(() => {
                this.controller && this.controller.abort();
                this.meta.current_page = 1;
                this.loadData();
            }, 400);
        },
        onPerPageChange() {
            localStorage.setItem('perPage_trainingTags', String(this.perPage));
            this.meta.current_page = 1;
            this.loadData();
        },
        download() {
            this.downloading = true;
            let params = {
                sort: this.sort.field,
                order: this.sort.order,
                search: this.search || undefined,
            }
            axios({
                url: '/training-tags?xlsx=1',
                method: 'GET',
                responseType: 'blob',
                params
            }).then((response) => {
                saveAs(response.data, 'training-tags.xlsx');
            }).finally(() => {
                this.downloading = false;
            });
        }
    },
    mounted() {
        this.loadData();
    },
    beforeUnmount() {
        this.controller && this.controller.abort();
    }
}

</script>
<template>
    <section>
        <div class="mb-4" v-if="$auth.isAdmin()">
            <b-button type="is-link" icon-left="download" @click="download" :loading="downloading">
                .xlsx
            </b-button>
        </div>

        <b-field>
            <b-input
                v-model="search"
                @input="onSearchInput"
                :placeholder="$t('labels.search') + '...'"
                type="search"
                icon="magnify"
                clearable/>
        </b-field>

        <b-table
            :data="loading ? [] : data"
            :loading="loading"

            :paginated="!loading"
            backend-pagination
            :total="loading ? 0 : meta.total"
            :per-page="perPage"
            @page-change="onPageChange"
            :aria-next-label="$t('navigation.next_page')"
            :aria-previous-label="$t('navigation.previous_page')"
            :aria-page-label="$t('navigation.page')"
            :aria-current-label="$t('navigation.current_page')"

            backend-sorting
            sort-icon="arrow-up"
            default-sort-direction="asc"
            :default-sort="['id', 'desc']"
            @sort="onSort">

            <template #empty>
                <div v-if="!loading" class="block has-text-grey has-text-centered mb-4 mt-4">
                    {{ $t('training_tags.labels.no_tags') }}
                </div>
            </template>

            <b-table-column field="id" label="ID" v-slot="props" sortable width="50px">
                {{ props.row.id }}
            </b-table-column>

            <b-table-column field="name" :label="$t('training_tags.fields.name.name')" sortable v-slot="props">
                <span v-if="!props.row.editing">{{ props.row.name }}</span>
                <b-input type="text" v-if="props.row.editing" v-model="props.row.name"
                         :disabled="props.row.saving"/>
            </b-table-column>

            <b-table-column field="created_at" :label="$t('training_tags.fields.created_at.name')" v-slot="props" sortable width="150px">
                {{ props.row.created_at_diff }}
            </b-table-column>


            <b-table-column field="" label="-" v-slot="props" width="80px">

                <section class="buttons">

                    <DeleteWithConfirmation
                        v-on:deleted="loadData"
                        small icon
                        :content="$t('training_tags.messages.removal_confirmation')"
                        :buttonTitle="$t('training_tags.labels.remove_tag')"
                        :url="'/training-tags/' + props.row.id"/>

                </section>

            </b-table-column>

            <template #bottom-left>
                <PerPageSelect v-model="perPage" @change="onPerPageChange" />
            </template>

        </b-table>

        <loader :loading="loading"></loader>
    </section>
</template>
